import React from "react";
import styles from "../Form.module.scss";
import {Switcher} from "uikit";
import {FieldInterface} from "@/types/Field.interface";

interface SwitcherGroupProps {
    fields: Record<string, FieldInterface>;
    handleChange: (field: string, value: boolean) => void;
}

const SwitcherGroup: React.FC<SwitcherGroupProps> = ({fields, handleChange}) => (
    <div className={styles.switcherRow}>
        <div className={styles.switcherCell}>
            <div className={styles.switcherlabel}>
                <div className={styles.switcherHeader}>
                    <span className={styles.switcherTitle}>Применять автоматически</span>
                </div>
                <p className={styles.switcherDescription}>
                    Промокод будет применён без ввода пользователем к каждому заказу, к которому подходит по параметрам
                </p>
            </div>
            <Switcher
                data-testid="autoUse-switch"
                id="autoUse"
                size="medium"
                value={fields.autoUse.value as boolean}
                onChange={(e) => handleChange('autoUse', e.target.checked)}
            />
        </div>

        <div className={styles.switcherCell}>
            <div className={styles.switcherlabel}>
                <div className={styles.switcherHeader}>
                    <span className={styles.switcherTitle}>Применять для консультаций</span>
                </div>
                <p className={styles.switcherDescription}>
                    Промокод будет применён автоматически при оформлении заказа через форму “Заказ консультации”
                </p>
            </div>
            <Switcher
                data-testid="autoUseConsult-switch"
                id="autoUseConsult"
                size="medium"
                value={fields.autoUseConsult.value as boolean}
                onChange={(e) => handleChange('autoUseConsult', e.target.checked)}
            />
        </div>

        <div className={styles.switcherCell}>
            <div className={styles.switcherlabel}>
                <div className={styles.switcherHeader}>
                    <span className={styles.switcherTitle}>Применять для опций</span>
                </div>
                <p className={styles.switcherDescription}>
                    Скидка, предоставляемая промокодом, будет применена к каждой опции билета
                </p>
            </div>
            <Switcher
                data-testid="useOptions-switch"
                id="useOptions"
                size="medium"
                value={fields.useOptions.value as boolean}
                onChange={(e) => handleChange('useOptions', e.target.checked)}
            />
        </div>

        <div className={styles.switcherCell}>
            <div className={styles.switcherlabel}>
                <div className={styles.switcherHeader}>
                    <span className={styles.switcherTitle}>Применять для сертификатов</span>
                </div>
                <p className={styles.switcherDescription}>
                    Промокод будет применён только при использовании проданных сертификатов
                </p>
            </div>
            <Switcher
                data-testid="isCertificate-switch"
                id="isCertificate"
                size="medium"
                value={fields.isCertificate.value as boolean}
                onChange={(e) => handleChange('isCertificate', e.target.checked)}
            />
        </div>
    </div>
);

export default SwitcherGroup;
